import { useState, Dispatch, SetStateAction } from 'react';

interface Filter {
  watchProvidersIds?: string[];
  genresIds?: number[];
}

function useFiltersQuery(): [Filter, Dispatch<SetStateAction<Filter>>] {
  const [filtersQuery, setFiltersQuery] = useState<Filter>({
    watchProvidersIds: [],
    genresIds: []
  });

  return [filtersQuery, setFiltersQuery];
}

export default useFiltersQuery;
